module.exports = __webpack_public_path__ + "img/500.ba863e12.png";